import React from 'react';
import styled, { css } from 'styled-components';
import { OnlineThemeType } from '../../themes/online';
import Logo from '../../assets/sunbit-logo-orange.svg';

export interface IBrandSmallProps {
  className?: string;
  title: string;
}

export interface IBrandSmallPropsWithTheme extends IBrandSmallProps {
  theme: OnlineThemeType;
}

const StyledBrandSmall = ({ theme }: IBrandSmallPropsWithTheme) => {
  return css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 7px;
    min-width: 150px;
    height: 100%;
    padding: 10px 20px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: ${theme.colors.primaryBackground};

    > img {
      height: 25px;
    }
    @media ${theme.device.tabletS} {
      display: none;
    }
  `;
};

export const BrandSmall = styled((props: IBrandSmallProps) => {
  return (
    <div className={props.className}>
      <img src={Logo} alt="logo" />
    </div>
  );
})`
  ${StyledBrandSmall}
`;
